import { OAuthCallback } from '../../../components';

export const Callback = () => {
  return <OAuthCallback />;
};
